import { render } from "./PrintCreateInvoiceProc.vue?vue&type=template&id=b6bce7a2&scoped=true"
import script from "./PrintCreateInvoiceProc.vue?vue&type=script&lang=js"
export * from "./PrintCreateInvoiceProc.vue?vue&type=script&lang=js"

import "./PrintCreateInvoiceProc.vue?vue&type=style&index=0&id=b6bce7a2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6bce7a2"]])

export default __exports__